/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './dereferenceScope.defs.js'
export * as $defs from './dereferenceScope.defs.js'
